module.exports = __webpack_public_path__ + "img/2_colette.0e0ed7a6.jpg";